import type {
  FulfillmentPartnerAdminApiContract,
  MedicationAdminApiInContract,
  MedicationStaffApiOutContract,
  ServiceCategory,
} from '@/api/generated/pwrdbyQuickMDAdminsApi.schemas'
import type { MedicationFormValues, FulfillmentPartnerFormValues } from '../types'

export function mapMedicationIn(data: MedicationFormValues, imageUrl: string): MedicationAdminApiInContract {
  return {
    Name: data.drugName,
    PatientDescription: data.displayDescription,
    ImageUrl: imageUrl,
    GenericCodeNumber: data.gcnEnabled ? data.gcn : null,
    NationalDrugCode: data.ndcEnabled ? data.ndc : null,
    AlternativeThirdPartyKey: data.otherEnabled ? data.otherDrugCode : null,
    IsControlledSubstance: data.isControlledSubstance,
    DispenseUnit: data.unit,
    // Bridge the form's category value to the generated ServiceCategory enum.
    Category: data.category as unknown as ServiceCategory,
    FulfillmentPartnerNcpdpIds: data.fulfillmentPartnerIds,
    Formulations: data.pricingTiers.map((tier) => ({
      Price: tier.patientPrice,
      TotalQuantity: tier.quantity,
    })),
  }
}

export function mapInToOut(id: string, apiData: MedicationAdminApiInContract): MedicationStaffApiOutContract {
  return {
    Id: id,
    Name: apiData.Name,
    PatientDescription: apiData.PatientDescription,
    ImageUrl: apiData.ImageUrl,
    DispenseUnit: apiData.DispenseUnit,
    Category: apiData.Category,
    GenericCodeNumber: apiData.GenericCodeNumber ?? null,
    NationalDrugCode: apiData.NationalDrugCode ?? null,
    AlternativeThirdPartyKey: apiData.AlternativeThirdPartyKey ?? null,
    IsControlledSubstance: apiData.IsControlledSubstance ?? false,
    Formulations: apiData.Formulations,
    FulfillmentPartnerNcpdpIds: apiData.FulfillmentPartnerNcpdpIds,
  }
}

export function mapFulfillmentPartnerIn(data: FulfillmentPartnerFormValues): FulfillmentPartnerAdminApiContract {
  return {
    Name: data.Name,
    NcpdpId: data.NcpdpId,
    SignatureRequirement: data.signatureRequired,
    ExcludedStateCodes: data.excludedStates,
    ShippingOptions: data.ShippingOptions,
  }
}
